import { useState, useCallback } from 'react';

const initialState = {
  autoplannerTask: null,
  trainingGroupId: null,
  selectedSessions: [],
  startDate: null,
  endDate: null,
  promptType: 'crew_consistent',
  sessionExclusions: {},
  resolutions: {},
  lockedSeatings: {},
};

export const useAutoplannerState = (selectedTask) => {
  const [formData, setFormData] = useState(initialState);

  const updateFormData = useCallback((updates) => {
    console.log('Updating form data with:', updates);
    setFormData((prev) => {
      const newData = { ...prev, ...updates };
      console.log('New form data:', newData);
      return newData;
    });
  }, []);

  return {
    formData,
    setFormData,
    updateFormData,
    initialState,
  };
};
